import { render, staticRenderFns } from "./userdetail.vue?vue&type=template&id=7981d28c&scoped=true&"
import script from "./userdetail.vue?vue&type=script&lang=js&"
export * from "./userdetail.vue?vue&type=script&lang=js&"
import style0 from "./userdetail.vue?vue&type=style&index=0&id=7981d28c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7981d28c",
  null
  
)

export default component.exports